import React from 'react';

import { EditorInput, SectionWrapper } from './styles';

interface EditorProps {
    onMarkdownChange: (md: string) => void;
    markdownValue?: string;
}

export const Editor = ({ onMarkdownChange, markdownValue = '' }: EditorProps) => {
    function handleValueChange(value = '') {
        onMarkdownChange(value);
    }

    return (
        <SectionWrapper>
            <EditorInput
                placeholder={'# your markdown goes here'}
                value={markdownValue}
                onChange={(e) => handleValueChange(e.target.value)}
            />
        </SectionWrapper>
    );
};
